jQuery(function($){
    var header_el = $('#masthead');
    var scroll_threshold = 200; // pixels
    function resizeHeader(){
        if ($(window).scrollTop() >= scroll_threshold) {
            header_el.removeClass('grow').addClass('shrink');
        } else if (header_el.hasClass('shrink')) {
            header_el.removeClass('shrink').addClass('grow');
        }
    }
    $(window).on('scroll', _.throttle(resizeHeader, 250));
    resizeHeader();
});
